export default __webpack_public_path__ + "static/execute-be556f9334864b0e1e7885ef2d516534.png";